//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RecipeFolderClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type UpdateRecipeFolderQueryParameters = {
  recipeFolderId: number ;
}

export type RemoveRecipeFolderQueryParameters = {
  recipeFolderId: number ;
}

export type GetRecipeFolderByPublicIdRecipeFolderQueryParameters = {
  folderPublicId: string ;
}

export type UpdateSortingRecipeFolderQueryParameters = {
  recipeFolderId: number ;
  sortingType?: Types.SortingType | undefined ;
  sortingDirection?: Types.SortDirection | undefined ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/recipe-folder";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'RecipeFolderClient',
      'create',
    ]);
}

/**
 * Creates a new recipe folder for the user.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.RecipeFolderDto, unknown, Types.CreateOrUpdateRecipeFolderDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeFolderDto, unknown, Types.CreateOrUpdateRecipeFolderDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateOrUpdateRecipeFolderDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getRecipeFoldersForUserUrl(): string {
  let url_ = getBaseUrl() + "/api/recipe-folder";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRecipeFoldersForUserDefaultOptions: Omit<UseQueryOptions<Types.RecipeFolderDto[], unknown, Types.RecipeFolderDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RecipeFolderDto[], unknown, Types.RecipeFolderDto[]>, 'queryFn'>> = {
};
export function getGetRecipeFoldersForUserDefaultOptions() {
  return getRecipeFoldersForUserDefaultOptions;
};
export function setGetRecipeFoldersForUserDefaultOptions(options: typeof getRecipeFoldersForUserDefaultOptions) {
  getRecipeFoldersForUserDefaultOptions = options;
}

export function getRecipeFoldersForUserQueryKey(): QueryKey;
export function getRecipeFoldersForUserQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'RecipeFolderClient',
      'getRecipeFoldersForUser',
    ]);
}
export function __getRecipeFoldersForUser(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getRecipeFoldersForUser(
axiosConfig    );
}

/**
 * Gets all recipe folders for the user.
 * @return List with all folders of the user.
 */
export function useGetRecipeFoldersForUserQuery<TSelectData = Types.RecipeFolderDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.RecipeFolderDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRecipeFoldersForUserQuery<TSelectData = Types.RecipeFolderDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RecipeFolderDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RecipeFolderDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getRecipeFoldersForUser(context, axiosConfig) : __getRecipeFoldersForUser,
    queryKey: getRecipeFoldersForUserQueryKey(),
    ...getRecipeFoldersForUserDefaultOptions as unknown as Omit<UseQueryOptions<Types.RecipeFolderDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all recipe folders for the user.
 * @return List with all folders of the user.
 */
export function setGetRecipeFoldersForUserData(queryClient: QueryClient, updater: (data: Types.RecipeFolderDto[] | undefined) => Types.RecipeFolderDto[], ) {
  queryClient.setQueryData(getRecipeFoldersForUserQueryKey(),
    updater
  );
}

/**
 * Gets all recipe folders for the user.
 * @return List with all folders of the user.
 */
export function setGetRecipeFoldersForUserDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RecipeFolderDto[] | undefined) => Types.RecipeFolderDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createCalculationTemplateUrl(): string {
  let url_ = getBaseUrl() + "/api/recipe-folder/calculation-template";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createCalculationTemplateMutationKey(): MutationKey {
  return trimArrayEnd([
      'RecipeFolderClient',
      'createCalculationTemplate',
    ]);
}

/**
 * Creates a new recipe folder for the user.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function useCreateCalculationTemplateMutation<TContext>(options?: Omit<UseMutationOptions<Types.RecipeFolderDto, unknown, Types.CreateOrUpdateRecipeFolderDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeFolderDto, unknown, Types.CreateOrUpdateRecipeFolderDto, TContext> {
  const key = createCalculationTemplateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateOrUpdateRecipeFolderDto) => Client.createCalculationTemplate(dto),
    mutationKey: key,
  });
}
  
export function updateUrl(recipeFolderId: number): string {
  let url_ = getBaseUrl() + "/api/recipe-folder/{recipeFolderId}";
if (recipeFolderId === undefined || recipeFolderId === null)
  throw new Error("The parameter 'recipeFolderId' must be defined.");
url_ = url_.replace("{recipeFolderId}", encodeURIComponent("" + recipeFolderId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateMutationKey(recipeFolderId: number): MutationKey {
  return trimArrayEnd([
      'RecipeFolderClient',
      'update',
      recipeFolderId as any,
    ]);
}

/**
 * Updates recipe folder for the user.
 * @param recipeFolderId Id of the folder to update.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function useUpdateMutation<TContext>(recipeFolderId: number, options?: Omit<UseMutationOptions<Types.RecipeFolderDto, unknown, Types.CreateOrUpdateRecipeFolderDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipeFolderDto, unknown, Types.CreateOrUpdateRecipeFolderDto, TContext> {
  const key = updateMutationKey(recipeFolderId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateOrUpdateRecipeFolderDto) => Client.update(recipeFolderId, dto),
    mutationKey: key,
  });
}
  
type Update__MutationParameters = UpdateRecipeFolderQueryParameters & {
  dto: Types.CreateOrUpdateRecipeFolderDto;
}

/**
 * Updates recipe folder for the user.
 * @param recipeFolderId Id of the folder to update.
 * @param dto Dto with data for creation.
 * @return Dto with recipe folder's data.
 */
export function useUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RecipeFolderDto, unknown, Update__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateRecipeFolderQueryParameters}): UseMutationResult<Types.RecipeFolderDto, unknown, Update__MutationParameters, TContext> {
  const key = updateMutationKey(options?.parameters?.recipeFolderId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Update__MutationParameters) => Client.update(data.recipeFolderId ?? options?.parameters?.recipeFolderId!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(recipeFolderId: number): string {
  let url_ = getBaseUrl() + "/api/recipe-folder/{recipeFolderId}";
if (recipeFolderId === undefined || recipeFolderId === null)
  throw new Error("The parameter 'recipeFolderId' must be defined.");
url_ = url_.replace("{recipeFolderId}", encodeURIComponent("" + recipeFolderId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(recipeFolderId: number): MutationKey {
  return trimArrayEnd([
      'RecipeFolderClient',
      'remove',
      recipeFolderId as any,
    ]);
}

/**
 * Deletes recipe folder for the user.
 * @return List with all folders of the user.
 */
export function useRemoveMutation<TContext>(recipeFolderId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(recipeFolderId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(recipeFolderId),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveRecipeFolderQueryParameters

/**
 * Deletes recipe folder for the user.
 * @return List with all folders of the user.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveRecipeFolderQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.recipeFolderId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.recipeFolderId ?? options?.parameters?.recipeFolderId!),
  mutationKey: key,
});
}
  
export function getRecipeFolderByPublicIdUrl(folderPublicId: string): string {
  let url_ = getBaseUrl() + "/api/recipe-folder/{folderPublicId}";
if (folderPublicId === undefined || folderPublicId === null)
  throw new Error("The parameter 'folderPublicId' must be defined.");
url_ = url_.replace("{folderPublicId}", encodeURIComponent("" + folderPublicId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRecipeFolderByPublicIdDefaultOptions: Omit<UseQueryOptions<Types.RecipePublicFolderDto, unknown, Types.RecipePublicFolderDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RecipePublicFolderDto, unknown, Types.RecipePublicFolderDto>, 'queryFn'>> = {
};
export function getGetRecipeFolderByPublicIdDefaultOptions() {
  return getRecipeFolderByPublicIdDefaultOptions;
};
export function setGetRecipeFolderByPublicIdDefaultOptions(options: typeof getRecipeFolderByPublicIdDefaultOptions) {
  getRecipeFolderByPublicIdDefaultOptions = options;
}

export function getRecipeFolderByPublicIdQueryKey(folderPublicId: string): QueryKey;
export function getRecipeFolderByPublicIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { folderPublicId,  } = params[0] as GetRecipeFolderByPublicIdRecipeFolderQueryParameters;

    return trimArrayEnd([
        'RecipeFolderClient',
        'getRecipeFolderByPublicId',
        folderPublicId as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipeFolderClient',
        'getRecipeFolderByPublicId',
        ...params
      ]);
  }
}
export function __getRecipeFolderByPublicId(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getRecipeFolderByPublicId(
      context.queryKey[2] as string,axiosConfig    );
}

export function useGetRecipeFolderByPublicIdQuery<TSelectData = Types.RecipePublicFolderDto, TError = unknown>(dto: GetRecipeFolderByPublicIdRecipeFolderQueryParameters, options?: Omit<UseQueryOptions<Types.RecipePublicFolderDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets recipe folders of the user.
 */
export function useGetRecipeFolderByPublicIdQuery<TSelectData = Types.RecipePublicFolderDto, TError = unknown>(folderPublicId: string, options?: Omit<UseQueryOptions<Types.RecipePublicFolderDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRecipeFolderByPublicIdQuery<TSelectData = Types.RecipePublicFolderDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RecipePublicFolderDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let folderPublicId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ folderPublicId,  } = params[0] as GetRecipeFolderByPublicIdRecipeFolderQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [folderPublicId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RecipePublicFolderDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getRecipeFolderByPublicId(context, axiosConfig) : __getRecipeFolderByPublicId,
    queryKey: getRecipeFolderByPublicIdQueryKey(folderPublicId),
    ...getRecipeFolderByPublicIdDefaultOptions as unknown as Omit<UseQueryOptions<Types.RecipePublicFolderDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets recipe folders of the user.
 */
export function setGetRecipeFolderByPublicIdData(queryClient: QueryClient, updater: (data: Types.RecipePublicFolderDto | undefined) => Types.RecipePublicFolderDto, folderPublicId: string) {
  queryClient.setQueryData(getRecipeFolderByPublicIdQueryKey(folderPublicId),
    updater
  );
}

/**
 * Gets recipe folders of the user.
 */
export function setGetRecipeFolderByPublicIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RecipePublicFolderDto | undefined) => Types.RecipePublicFolderDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateSortingUrl(recipeFolderId: number, sortingType?: Types.SortingType | undefined, sortingDirection?: Types.SortDirection | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe-folder/{recipeFolderId}/recipes-sorting?";
if (recipeFolderId === undefined || recipeFolderId === null)
  throw new Error("The parameter 'recipeFolderId' must be defined.");
url_ = url_.replace("{recipeFolderId}", encodeURIComponent("" + recipeFolderId));
if (sortingType === null)
    throw new Error("The parameter 'sortingType' cannot be null.");
else if (sortingType !== undefined)
    url_ += "sortingType=" + encodeURIComponent("" + sortingType) + "&";
if (sortingDirection === null)
    throw new Error("The parameter 'sortingDirection' cannot be null.");
else if (sortingDirection !== undefined)
    url_ += "sortingDirection=" + encodeURIComponent("" + sortingDirection) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateSortingMutationKey(recipeFolderId: number, sortingType?: Types.SortingType | undefined, sortingDirection?: Types.SortDirection | undefined): MutationKey {
  return trimArrayEnd([
      'RecipeFolderClient',
      'updateSorting',
      recipeFolderId as any,
      sortingType as any,
      sortingDirection as any,
    ]);
}

/**
 * Updates recipes sorting in the folder.
 * @param recipeFolderId Id of the folder to update.
 * @param sortingType (optional) Type of recipes sorting in the RecipeFolder
 * @param sortingDirection (optional) Direction of recipes sorting in the RecipeFolder
 */
export function useUpdateSortingMutation<TContext>(recipeFolderId: number, sortingType?: Types.SortingType | undefined, sortingDirection?: Types.SortDirection | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = updateSortingMutationKey(recipeFolderId, sortingType, sortingDirection);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.updateSorting(recipeFolderId, sortingType, sortingDirection),
    mutationKey: key,
  });
}
  
type UpdateSorting__MutationParameters = UpdateSortingRecipeFolderQueryParameters

/**
 * Updates recipes sorting in the folder.
 * @param recipeFolderId Id of the folder to update.
 * @param sortingType (optional) Type of recipes sorting in the RecipeFolder
 * @param sortingDirection (optional) Direction of recipes sorting in the RecipeFolder
 */
export function useUpdateSortingMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UpdateSorting__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateSortingRecipeFolderQueryParameters}): UseMutationResult<void, unknown, UpdateSorting__MutationParameters, TContext> {
  const key = updateSortingMutationKey(options?.parameters?.recipeFolderId!, options?.parameters?.sortingType!, options?.parameters?.sortingDirection!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateSorting__MutationParameters) => Client.updateSorting(data.recipeFolderId ?? options?.parameters?.recipeFolderId!, data.sortingType ?? options?.parameters?.sortingType!, data.sortingDirection ?? options?.parameters?.sortingDirection!),
  mutationKey: key,
});
}